<template>
  <div class="data-label-wrapper" :style="dataLabelStyles">
    <div class="circle-color-identifier"></div>
    <div class="data-label-data">
      <h5 class="label">{{ label }}</h5>
      <h3 class="data">{{ labelData }}</h3>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // left: 125,
    };
  },
  computed: {
    dataLabelStyles() {
      return {
        "--dataLabelColor": this.color,
      };
    },
  },
  methods: {},
  created() {},
  components: {},
  props: ["label", "labelData", "left", "color"],
};
</script>
<style scoped>
.data-label-wrapper {
  /* height: 250px; */
  /* width: 60px; */
  /* position: absolute; */
  margin: 5px;
  display: flex;
  align-items: center;
}

.circle-color-identifier {
  height: 25px;
  width: 25px;
  margin-right: 10px;
  border-radius: 15px;
  background-color: var(--dataLabelColor);
  filter: drop-shadow(0px 2px 2px var(--secondaryColor));
}

h5,
h3 {
  margin: 0px;
  font-family: Roboto;
}

h3 {
  font-size: 12pt;
}

h5 {
  font-weight: 400;
  font-size: 8pt;
}

.data-label-data {
  padding: 5px 20px;
  background-color: var(--backgroundColor);
  border-radius: 4px;
  filter: drop-shadow(0px 2px 2px var(--secondaryColor));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
</style>
